export const TreeGridNameColumn = {
  field: 'name',
  title: 'Name',
  width: 320,
  expandable: true
};

export const TreeGridOptimizeStatusColumn = {
  field: 'optimizeStatus',
  title: 'Optimization',
  width: 170,
  expandable: false
};

export const TreeGridDataPrivacyColumn = {
  field: 'data',
  title: 'Data privacy',
  width: 170,
  expandable: false
};

export const TreeGridLinksColumn = {
  field: 'links',
  title: '# of links',
  width: 110,
  expandable: false
};

export const TreeGridStatusColumn = {
  field: 'status',
  title: 'Status',
  width: 110,
  expandable: false
};

export const TreeGridImpactColumn = {
  field: 'impact',
  title: 'Field impact',
  width: 150,
  expandable: false
};

export const TreeGridTagsColumn = {
  field: 'tags',
  title: 'Tags',
  width: 400,
  expandable: false
};
